/* 상세페이지 구매 박스 (snippets/nc-buy-box.liquid)
   - 위쪽 정보 영역 / 오른쪽 고정 패널이 같은 선택 목록을 공유
   - 선택한 옵션·추가 구성 상품이 아래에 한 줄씩 쌓임 */
(() => {
  const boxes = [...document.querySelectorAll('[data-nc-buy]')];
  if (!boxes.length) return;

  let data;
  try { data = JSON.parse(document.querySelector('[data-nc-pd-data]').textContent); } catch (e) { return; }

  const fmt = (cents) => '₩' + Math.round(cents / 100).toLocaleString('ko-KR');
  const toCents = (p) => (typeof p === 'string' ? Math.round(parseFloat(p) * 100) : Number(p));
  const esc = (s) => String(s).replace(/[&<>"]/g, (c) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]));

  /* ===== 직접 만든 선택창 (PC: 흰 목록 / 모바일: 화면 아래에서 꽉 차게) ===== */
  let openDd = null;
  const closeDd = () => {
    if (!openDd) return;
    openDd.wrap.classList.remove('is-open');
    openDd.sheet.remove();
    document.documentElement.classList.remove('nc-dd-lock');
    openDd = null;
  };
  document.addEventListener('click', (e) => { if (openDd && !e.target.closest('.nc-dd, .nc-dd-sheet')) closeDd(); });
  document.addEventListener('keydown', (e) => { if (e.key === 'Escape') closeDd(); });

  const enhanceSelect = (sel) => {
    if (sel.dataset.ncDd) return;
    sel.dataset.ncDd = '1';
    const wrap = document.createElement('div');
    wrap.className = 'nc-dd';
    sel.parentNode.insertBefore(wrap, sel);
    wrap.appendChild(sel);
    sel.classList.add('nc-dd__native');
    sel.tabIndex = -1;
    const btn = document.createElement('button');
    btn.type = 'button';
    btn.className = 'nc-dd__btn' + (sel.classList.contains('nc-buy__select') && sel.closest('.nc-buy__addon') ? ' nc-dd__btn--sm' : '');
    const label = () => { btn.textContent = sel.selectedOptions[0] ? sel.selectedOptions[0].textContent : ''; };
    label();
    wrap.appendChild(btn);
    sel.addEventListener('change', () => setTimeout(label, 0));

    btn.addEventListener('click', (e) => {
      e.stopPropagation();
      const was = openDd && openDd.wrap === wrap;
      closeDd();
      if (was) return;
      const mobile = matchMedia('(max-width: 749px)').matches;
      const sheet = document.createElement('div');
      sheet.className = 'nc-dd-sheet' + (mobile ? ' nc-dd-sheet--mobile' : '');
      const opts = [...sel.options].filter((o) => o.value !== '');
      sheet.innerHTML =
        (mobile ? `<div class="nc-dd-sheet__head"><span>${esc(sel.options[0].textContent)}</span><button type="button" class="nc-dd-sheet__close" aria-label="닫기">×</button></div>` : '') +
        `<ul class="nc-dd-sheet__list">${opts.map((o) => `<li><button type="button" data-v="${esc(o.value)}" ${o.disabled ? 'disabled' : ''}>${esc(o.textContent)}</button></li>`).join('')}</ul>`;
      if (mobile) {
        sheet.insertAdjacentHTML('afterbegin', '<div class="nc-dd-sheet__dim"></div>');
        document.body.appendChild(sheet);
        document.documentElement.classList.add('nc-dd-lock');
      } else {
        wrap.appendChild(sheet);
      }
      wrap.classList.add('is-open');
      openDd = { wrap, sheet };
      sheet.addEventListener('click', (ev) => {
        ev.stopPropagation();
        if (ev.target.closest('.nc-dd-sheet__close, .nc-dd-sheet__dim')) { closeDd(); return; }
        const b = ev.target.closest('button[data-v]');
        if (!b || b.disabled) return;
        sel.value = b.dataset.v;
        closeDd();
        sel.dispatchEvent(new Event('change', { bubbles: true }));
      });
    });
  };
  const enhanceAll = (root) => root.querySelectorAll('select.nc-buy__select').forEach(enhanceSelect);

  /* ===== 선택 목록 ===== */
  const lines = [];
  const variantTitle = (v) => (data.hasOnlyDefault ? data.title : data.title + ' - ' + v.title);

  const addLine = (line) => {
    const found = lines.find((l) => String(l.id) === String(line.id));
    if (found) { if (!line.silent) found.qty += 1; }
    else lines.push({ id: line.id, title: line.title, price: line.price, qty: 1, main: !!line.main });
    render();
  };

  const mainVariant = (id) => data.variants.find((v) => String(v.id) === String(id));

  /* 단일 상품만 처음부터 1개 담긴 상태 / 옵션 상품은 직접 선택해야 함 */
  const first = mainVariant(data.currentVariant);
  if (data.hasOnlyDefault && first && first.available) lines.push({ id: first.id, title: variantTitle(first), price: first.price, qty: 1, main: true });

  /* ===== 렌더 ===== */
  const cartOthers = () => {
    const ids = lines.map((l) => String(l.id));
    return data.cart.items
      .filter((i) => !ids.includes(String(i.variant_id)))
      .reduce((sum, i) => sum + i.final_line_price, 0);
  };

  const render = () => {
    const total = lines.reduce((s, l) => s + l.price * l.qty, 0);
    const count = lines.reduce((s, l) => s + l.qty, 0);

    boxes.forEach((box) => {
      box.querySelector('[data-nc-buy-lines]').innerHTML = lines.map((l, i) => `
        <li class="nc-buy__line" data-i="${i}">
          <div class="nc-buy__line-head">
            <span class="nc-buy__line-title">${esc(l.title)}</span>
            <button type="button" class="nc-buy__line-del" data-del aria-label="삭제">
              <svg viewBox="0 0 24 24" aria-hidden="true"><path d="M6 6l12 12M18 6L6 18"/></svg>
            </button>
          </div>
          <div class="nc-buy__line-foot">
            <div class="nc-buy__qty">
              <button type="button" data-minus aria-label="수량 빼기">−</button>
              <input type="number" min="1" value="${l.qty}" data-qty aria-label="수량">
              <button type="button" data-plus aria-label="수량 더하기">+</button>
            </div>
            <span class="nc-buy__line-price">${fmt(l.price * l.qty)}</span>
          </div>
        </li>`).join('');

      box.querySelector('[data-nc-buy-total]').textContent = fmt(total);
      box.querySelector('[data-nc-buy-count]').textContent = '(' + count + '개)';
      box.querySelectorAll('[data-nc-buy-add],[data-nc-buy-now]').forEach((b) => { b.classList.toggle('is-empty', !lines.length); });

      const msg = box.querySelector('[data-nc-buy-ship-msg]');
      if (msg && data.shipMin) {
        const projected = cartOthers() + total;
        const remain = data.shipMin - projected;
        msg.innerHTML = remain > 0
          ? '<b>' + fmt(remain) + '</b>만 더 구매하면 <b>무료배송!</b>'
          : '<b>무료배송</b> 자격이 있습니다!';
        box.querySelector('[data-nc-buy-ship-bar]').style.width = Math.min(100, Math.round((projected / data.shipMin) * 100)) + '%';
      }
    });
  };

  /* ===== 이벤트 ===== */
  boxes.forEach((box) => {
    box.querySelector('[data-nc-buy-lines]').addEventListener('click', (e) => {
      const li = e.target.closest('[data-i]');
      if (!li) return;
      const l = lines[Number(li.dataset.i)];
      if (e.target.closest('[data-del]')) lines.splice(Number(li.dataset.i), 1);
      else if (e.target.closest('[data-plus]')) l.qty += 1;
      else if (e.target.closest('[data-minus]')) l.qty = Math.max(1, l.qty - 1);
      else return;
      render();
    });
    box.querySelector('[data-nc-buy-lines]').addEventListener('change', (e) => {
      const li = e.target.closest('[data-i]');
      if (!li || !e.target.matches('[data-qty]')) return;
      lines[Number(li.dataset.i)].qty = Math.max(1, parseInt(e.target.value, 10) || 1);
      render();
    });

    const sel = box.querySelector('[data-nc-buy-variant]');
    if (sel) sel.addEventListener('change', () => {
      const v = mainVariant(sel.value);
      if (v) addLine({ id: v.id, title: variantTitle(v), price: v.price, main: true });
      sel.value = '';
    });

    box.querySelector('[data-nc-buy-add]').addEventListener('click', (e) => submit(e.currentTarget, false));
    box.querySelector('[data-nc-buy-now]').addEventListener('click', (e) => submit(e.currentTarget, true));
  });

  /* 위쪽 옵션 버튼(300g/1kg 등)을 누르면 그 옵션 줄 추가 */
  const info = document.querySelector('.product__info-container');
  if (info) info.addEventListener('change', (e) => {
    const picker = e.target.closest('variant-selects, variant-radios, variant-tab-selects, variant-tab-radios');
    if (!picker) return;
    const values = [...picker.querySelectorAll('fieldset, .product-form__input')]
      .map((f) => {
        const checked = f.querySelector('input:checked');
        const select = f.querySelector('select');
        return checked ? checked.value : select ? select.value : null;
      })
      .filter((x) => x !== null);
    const v = data.variants.find((x) => x.options.length === values.length && x.options.every((o, i) => o === values[i]));
    if (!v || !v.available) return;
    addLine({ id: v.id, title: variantTitle(v), price: v.price, main: true, silent: true });
  });
  if (window.subscribe && window.PUB_SUB_EVENTS) subscribe(PUB_SUB_EVENTS.cartUpdate, () => refreshCart());

  const refreshCart = async () => {
    try { data.cart = await (await fetch('/cart.js')).json(); render(); } catch (e) {}
  };

  /* ===== 추가 구성 상품 ===== */
  const loadAddons = async () => {
    let products = [];
    try {
      const r = await fetch(`${data.recUrl}.json?product_id=${data.productId}&intent=complementary&limit=10`);
      if (r.ok) products = (await r.json()).products || [];
    } catch (e) {}
    if (!products.length && data.addonCollection) {
      try {
        const r = await fetch(`/collections/${data.addonCollection}/products.json?limit=20`);
        if (r.ok) products = (await r.json()).products || [];
      } catch (e) {}
    }
    /* 첫구매 전용 상품은 추가 구성에서 제외 */
    const isFirstBuy = (p) => /첫구매/.test(p.title || '') || [].concat(p.tags || []).some((t) => /첫구매/.test(t));
    products = products
      .filter((p) => String(p.id) !== String(data.productId))
      .filter((p) => !isFirstBuy(p))
      .filter((p) => (p.variants || []).some((v) => v.available !== false))
      .slice(0, 5);
    if (!products.length) return;

    const html = products.map((p, pi) => {
      const img = p.featured_image || (p.images && p.images[0] && (p.images[0].src || p.images[0])) || '';
      const imgSrc = typeof img === 'string' ? img : img.src || '';
      const variants = p.variants.filter((v) => v.available !== false);
      const single = p.variants.length === 1;
      const minPrice = Math.min(...variants.map((v) => toCents(v.price)));
      const options = variants.map((v) => `<option value="${v.id}" data-price="${toCents(v.price)}" data-title="${esc(single ? p.title : p.title + ' - ' + v.title)}">${esc(single ? p.title : v.title)} (${fmt(toCents(v.price))})</option>`).join('');
      return `
        <li class="nc-buy__addon">
          <a class="nc-buy__addon-img" href="/products/${p.handle}">${imgSrc ? `<img src="${imgSrc}${imgSrc.includes('?') ? '&' : '?'}width=200" alt="" loading="lazy">` : ''}</a>
          <div class="nc-buy__addon-info">
            <p class="nc-buy__addon-title">${esc(p.title)}</p>
            <p class="nc-buy__addon-price">${fmt(minPrice)}</p>
            <select class="nc-buy__select" data-addon="${pi}">
              <option value="">- [선택] ${single ? '상품' : '옵션'} 선택 -</option>
              ${options}
            </select>
          </div>
        </li>`;
    }).join('');

    boxes.forEach((box) => {
      const wrap = box.querySelector('[data-nc-buy-addons]');
      wrap.querySelector('[data-nc-buy-addon-list]').innerHTML = html;
      wrap.hidden = false;
      enhanceAll(wrap);
      wrap.addEventListener('change', (e) => {
        const s = e.target.closest('select[data-addon]');
        if (!s || !s.value) return;
        const o = s.selectedOptions[0];
        addLine({ id: Number(s.value), title: o.dataset.title, price: Number(o.dataset.price) });
        s.value = '';
      });
    });
  };

  /* ===== 장바구니 / 구매하기 ===== */
  const addAll = async (silent) => {
    const drawer = document.querySelector('cart-drawer');
    const body = { items: lines.map((l) => ({ id: Number(l.id), quantity: l.qty })) };
    if (drawer) {
      body.sections = drawer.getSectionsToRender().map((s) => s.id).join(',');
      body.sections_url = location.pathname;
    }
    const res = await fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      body: JSON.stringify(body)
    });
    const json = await res.json();
    if (json.status) {
      if (!silent) alert(json.description || json.message || '장바구니에 담지 못했습니다.');
      return null;
    }
    return { json, drawer };
  };

  const submit = async (btn, buyNow) => {
    if (!lines.length) {
      /* 옵션을 안 고른 경우: 위쪽 선택창으로 이동해서 바로 열기 */
      const topBox = boxes.find((b) => b.dataset.ncBuy === 'top') || boxes[0];
      const ddBtn = topBox.querySelector('.nc-dd__btn');
      topBox.scrollIntoView({ behavior: 'smooth', block: 'center' });
      if (ddBtn) setTimeout(() => ddBtn.click(), 400);
      else alert('옵션을 선택해 주세요.');
      return;
    }
    btn.disabled = true;
    try {
      if (buyNow && !data.loggedIn) {
        /* 비로그인: 선택 목록을 기억해 두고 로그인 → 로그인 후 담고 바로 결제 (snippets/nc-pending-buy.liquid) */
        try {
          sessionStorage.setItem('ncPendingBuy', JSON.stringify({ items: lines.map((l) => ({ id: l.id, quantity: l.qty })), t: Date.now() }));
        } catch (e) {}
        location.href = data.loginUrl + '?return_to=' + encodeURIComponent(location.pathname);
        return;
      }
      const r = await addAll(false);
      if (!r) return;
      if (buyNow) { location.href = '/checkout'; return; }
      if (r.drawer) { r.drawer.classList.remove('is-empty'); r.drawer.renderContents(r.json); refreshCart(); }
      else location.href = window.routes?.cart_url || '/cart';
    } finally {
      btn.disabled = false;
    }
  };

  /* 위쪽 구매 박스가 보이는 동안엔 오른쪽 패널 숨김 → 위쪽 박스가 화면 위로 지나가면 표시 */
  const topBox = boxes.find((b) => b.dataset.ncBuy === 'top');
  const sideWrap = document.querySelector('.nc-pd__side');
  if (topBox && sideWrap && 'IntersectionObserver' in window) {
    sideWrap.classList.add('nc-side-wait');
    new IntersectionObserver(([entry]) => {
      const passed = !entry.isIntersecting && entry.boundingClientRect.bottom < 0;
      sideWrap.classList.toggle('is-shown', passed);
    }).observe(topBox);
  }

  boxes.forEach(enhanceAll);
  render();
  loadAddons();
})();

/* ===== 리뷰 요약: Judge.me 데이터로 숫자·막대·문구 (snippets/nc-review-summary.liquid) ===== */
(() => {
  document.querySelectorAll('[data-nc-rv]').forEach((rv) => {
    const widget = document.getElementById('judgeme_product_reviews');
    const counts = { 5: 0, 4: 0, 3: 0, 2: 0, 1: 0 };
    let total = Number(rv.dataset.count) || 0;
    let avg = Number(rv.dataset.rating) || 0;
    if (widget) {
      widget.querySelectorAll('.jdgm-histogram__row[data-rating]').forEach((row) => {
        const star = Number(row.dataset.rating);
        if (counts[star] !== undefined) counts[star] = Number(row.dataset.frequency) || 0;
      });
      const a = widget.querySelector('[data-average-rating]');
      const n = widget.querySelector('[data-number-of-reviews]');
      if (a) avg = Number(a.dataset.averageRating) || avg;
      if (n) total = Number(n.dataset.numberOfReviews) || total;
    }
    const histTotal = Object.values(counts).reduce((x, y) => x + y, 0);
    if (total > 0) {
      rv.hidden = false;
      rv.querySelector('[data-nc-rv-rating]').textContent = avg.toFixed(1);
      rv.querySelector('[data-nc-rv-count]').textContent = total.toLocaleString('ko-KR');
      rv.querySelector('[data-nc-rv-stars]').style.width = Math.min(100, (avg / 5) * 100) + '%';
      rv.querySelectorAll('[data-nc-rv-bars] li').forEach((li) => {
        const c = counts[li.dataset.star] || 0;
        li.querySelector('.nc-rv__bar span').style.width = (histTotal ? (c / histTotal) * 100 : 0) + '%';
        li.querySelector('.nc-rv__bar-num').textContent = c.toLocaleString('ko-KR');
      });

      const pct = (n) => (histTotal ? Math.round((n / histTotal) * 100) : 0);
      const p5 = pct(counts[5]);
      const p45 = pct(counts[5] + counts[4]);
      const vars = { count: total.toLocaleString('ko-KR'), rating: avg.toFixed(1), p5, p45 };
      const fill = (t) => t.replace(/\{(count|rating|p5|p45)\}/g, (_, k) => vars[k]);
      const toHtml = (t) => fill(t).replace(/[&<>"]/g, (c) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]))
        .replace(/\[([^\]]+)\]/g, '<b>$1</b>');

      let custom = [];
      try { custom = JSON.parse(document.getElementById('NcRvCustom').textContent).filter(Boolean); } catch (e) {}
      const auto = ['고객 [{count}명]이 평균 [{rating}점]을 준 제품이에요!'];
      if (histTotal) {
        if (p5 >= 50) auto.push('리뷰의 [{p5}%]가 [5점 만점]을 줬어요!');
        if (p45 >= 60) auto.push('[{p45}%]의 고객이 [4점 이상]으로 만족했어요!');
      }
      const phrases = custom.concat(auto);
      const box = rv.querySelector('[data-nc-rv-phrase]');
      let i = Math.floor(Math.random() * phrases.length);
      box.innerHTML = toHtml(phrases[i]);
      if (phrases.length > 1) {
        setInterval(() => {
          box.classList.add('is-fade');
          setTimeout(() => {
            i = (i + 1) % phrases.length;
            box.innerHTML = toHtml(phrases[i]);
            box.classList.remove('is-fade');
          }, 350);
        }, 4000);
      }
    }
  });
})();
